/**
 * SleemAI coming-soon page (F100.1)
 *
 * Public /sleemai surface, rendered inside PortfolioSite (shared header/footer).
 * Copy follows the Voice & Style rules: first person, plain words, commas not
 * em-dashes, no banned phrases, and the site-wide safety overlay applies.
 */

import React from 'react';
import SubscribeForm from './SubscribeForm';

const SleemAI = () => (
  <div className="py-10 px-4">
    <div className="max-w-3xl mx-auto">
      <div className="text-center mb-10">
        <span className="inline-block px-5 py-2 text-base font-semibold rounded-full bg-sky-100 text-sky-700 dark:bg-sky-900/40 dark:text-sky-300 border border-sky-300 dark:border-sky-700 mb-5">
          Coming soon
        </span>
        <h1 className="text-3xl md:text-4xl font-bold font-heading text-slate-900 dark:text-slate-50">
          SleemAI
        </h1>
        <p className="mt-3 text-slate-600 dark:text-slate-300">
          The tools I build to learn agentic AI, published as working demos.
        </p>
      </div>

      <div className="space-y-6">
        <div className="rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 p-6">
          <h2 className="text-lg font-semibold text-slate-900 dark:text-slate-100 mb-2">
            Concept zero: build the tools I use
          </h2>
          <p className="text-slate-600 dark:text-slate-300 text-sm leading-relaxed">
            I get more productive by building my own tooling, and I learn agentic AI by
            building it. A product-owner dashboard that tracks repos, epics, features, and
            tasks. A budget app that keeps AI costs in check. A configuration dashboard that
            inventories my commands, agents, and plugins. A token dashboard that measures
            productivity per session. Each one is small, real, and in daily use.
          </p>
        </div>

        <div className="rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 p-6">
          <h2 className="text-lg font-semibold text-slate-900 dark:text-slate-100 mb-2">
            Concept one: from one-to-one to one-to-many
          </h2>
          <p className="text-slate-600 dark:text-slate-300 text-sm leading-relaxed">
            Today I build features one at a time, with my eyes on each step. The goal is to
            specify epics and features well enough that I can hand them to multiple AI
            sessions at once and let them build in parallel. The blog documents that journey,
            this page is where the results will land.
          </p>
        </div>

        <div className="rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 p-6">
          <h2 className="text-lg font-semibold text-slate-900 dark:text-slate-100 mb-2">
            One shared brain
          </h2>
          <p className="text-slate-600 dark:text-slate-300 text-sm leading-relaxed">
            The tools will not stay isolated. The plan is an open-brain setup where they share
            one memory, so each app makes the others smarter, and nothing is locked to a
            single AI vendor.
          </p>
        </div>
      </div>

      <div className="mt-12 pt-8 border-t border-slate-200 dark:border-slate-700">
        <SubscribeForm />
      </div>
    </div>
  </div>
);

export default SleemAI;
